import { Flex } from '@shared/components';

import { useExamDistributionListSearchParams } from '../../hooks/use-exam-distribution-list-search-params';
import { ExamCenterSearchSelection } from '../exam-center-search-selection';
import { ExamDistributionYearSelection } from '../exam-distribution-year-selection';

export default function ExamDistributionListFilterSection() {
  const [{ examCenters }, { handleExamCenterChange }] = useExamDistributionListSearchParams();

  return (
    <Flex sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
      <ExamDistributionYearSelection />
      <ExamCenterSearchSelection value={examCenters} onChange={handleExamCenterChange} />
    </Flex>
  );
}
